module.exports = __webpack_public_path__ + "static/media/validacao_localizacao_dark.9ab593b7.svg";